module.exports = __webpack_public_path__ + "static/media/home-banner-nick.344a6e1c.png";